import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "duplicate",
  "use": "duplicate-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"duplicate\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 2v9s0 2-2 2h-1v1c0 2-2 2-2 2H2s-2 0-2-2V5s0-2 2-2h2V2s0-2 2-2h8c2 0 2 2 2 2zm-2 10h-1V5s0-2-2-2H5V2c0-1 1-1 1-1h8s1 0 1 1v9s0 1-1 1zM1 5v9s0 1 1 1h9c1 0 1-1 1-1V5s0-1-1-1H2C1 4 1 5 1 5zm5 4H4.357S4 9 4 9.5s.357.5.357.5H6v1.5s0 .5.5.5.5-.5.5-.5V10h1.643S9 10 9 9.5 8.643 9 8.643 9H7V7.5S7 7 6.5 7s-.5.5-.5.5V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol